import type { SelectorOption } from '@/app/components/form/Selector/types';
import type { AgentListItem } from '@/types/clientTasksApiTypes';

export const mapAgentOptions = (agents: AgentListItem[]): SelectorOption<string>[] =>
  agents.map((a) => ({
    value: String(a.id),
    label: a.full_name ?? '',
    image: a.image_relative_url ?? undefined,
  }));
